---
title: "Internal vs. External Locations"
slug: internal-vs-external-locations
description: "Internal locations can scan packages; external locations are recipients outside your organization."
keywords:
  - location
  - internal
  - external
  - recipient
  - scan
  - package status
  - pending
---

## What is an internal location?

An internal location is a site that belongs to your organization and actively participates in the packaging cycle. Users with the Scanner, Manager, or Admin role can send and receive packages there.

Typical examples: warehouse, production facility, branch office, or an office location.

Internal locations appear in the dropdown list when you start a scan. You must have at least one internal location set up before you can send or receive your first package.

## What is an external location?

An external location (also called an external recipient) is an address outside your organization — for example, a customer, a partner, or a service provider.

External locations **cannot scan packages**. They are destination addresses only. Once a package is sent to an external location, it remains with the status **"In Transit"** until it is scanned back in at an internal location.

## Package status: pending until return

When you send a package to an external location, its status changes to **"In Transit"**. The package is considered on loan — not lost or billed.

The status only changes back to **"Available"** when the package is received (scanned back in) at one of your internal locations. That is when the cycle is closed.

As long as a package is with an external recipient, hey circle automatically monitors the return process: if the recipient keeps the package too long, you receive a reminder and later an invoice (see [Package Lifecycle](/app/help?article=package-lifecycle)).

## Quick comparison

| | Internal Location | External Location |
|---|---|---|
| Can scan | Yes | No |
| Can receive packages (scan) | Yes | No |
| Appears as sender/recipient selection | Yes | As recipient only |
| Packages return from here | Yes | No — package returns only after an internal scan |

## Related Articles

- [Sending a Package](/app/help?article=sending-a-package)
- [Receiving a Package](/app/help?article=scanning-a-package)
- [Package Lifecycle](/app/help?article=package-lifecycle)
- [Initial Setup](/app/help?article=initial-setup)
